import { createContext } from "react";

export const PermissionsContext = createContext([]);
